import * as localforage from "localforage";
import { phpRequest } from "./phpRequest";

export const getCountriesAPI = async () => {
  const data = await phpRequest.get("/countries");
  const allCountriesData = data.countries;
  const countriesNamesAndIDs = allCountriesData.map((countryData) => {
    const filteredCountryData = {
      name: countryData.name,
      id: countryData.id,
    };
    return filteredCountryData;
  });
  await localforage.setItem("countries", countriesNamesAndIDs);
};
